import { PageDetail } from '@components/pageDetail/PageDetail';
import { Seo } from '@components/seo/Seo';

import { checkPagePreviewAccess } from '@common/utils/access';
import { isDevelopment } from '@common/utils/environment';
import {
	getEventsCollections,
	serverSideWithSiteData,
} from '@common/utils/page';
import { DEFAULT_IMGIX_PARAMS } from '@data/constants';
import { queryFromDato } from '@data/datocms/client';
import { pageQuery } from '@data/datocms/queries';
import { supabaseAdminClient } from '@data/supabase/adminClient';
import { PageResponse, SiteData } from '@interfaces';

const Page = ({
	page,
	programme,
	site: { faviconMetaTags },
}: PageResponse & SiteData) => {
	return (
		<>
			<Seo metaTagData={[...page.seoMetaTags, ...faviconMetaTags]} />
			<PageDetail page={page} programmeLabels={programme} />
		</>
	);
};

export const getServerSideProps = serverSideWithSiteData<PageResponse>(
	async (context) => {
		const slug = String(context.params?.slug);
		const isSharedPreview = await checkPagePreviewAccess(context.query, slug);
		const includeDrafts =
			isDevelopment() || context.draftMode || isSharedPreview;

		const pageResponse = await queryFromDato<PageResponse>({
			query: pageQuery,
			variables: {
				slug,
				imgixParams: DEFAULT_IMGIX_PARAMS,
			},
			includeDrafts,
		});

		const page = pageResponse?.page;
		const programme = pageResponse?.programme;

		if (!page || !programme) {
			return {
				notFound: true,
			};
		}

		// WARN: this changes the page in place
		await getEventsCollections(page, supabaseAdminClient);

		return {
			props: {
				page,
				programme,
			},
		};
	},
);

export default Page;
